import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'
import { param } from 'jquery';


export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetPaymentServiceDetails() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetPaymentServiceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ConnectStripeAccount() {
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConnectStripeAccount,null,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ConnectStripeAccountAttention() {
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConnectStripeAccountAttention,null,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}
export function UpdateAcceptOnlinePaymentsOption(optionValue) {
    const option = {
        optionValue    
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AcceptOnlinePaymentsOptionUpdate, option,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetLoginLink() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConnectStripeLoginLink,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DisconnectStripeAccount() {

    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisconnectStripeAccount,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function RefreshBalances() {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Balance,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetSite() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Site,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateBookingPortalStatus(status) {
    const statusData = {
        status
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.BookingPortalStatus, statusData,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateSiteContactDetails(addressNumberName, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode, phoneNumber, email) {
    const siteContactDetailsDto = {
        addressNumberName,
        addressFirstLine,
        addressSecondLine,
        addressCity,
        addressCounty,
        addressPostcode,
        phoneNumber,
        email
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteContactDetails, siteContactDetailsDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateTheme(themeIdValue) {
    const themeId = {
        themeIdValue
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Theme, themeId,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateConfigAddress(addressNumberName, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode) {
    const siteContactDetailsDto = {
        addressNumberName,
        addressFirstLine,
        addressSecondLine,
        addressCity,
        addressCounty,
        addressPostcode
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ConfigAddress, siteContactDetailsDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateTerms(termsText) {
    const Terms = {
        termsText
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Terms, Terms,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateWebsiteLink(termsText) {
    const Terms = {
        termsText
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Website, Terms,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateCurrency(currency) {
    const CurrencyDto = {
        currency
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Currency, CurrencyDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}